<template>
  <v-row class="p-0">
    <v-col v-if="resumeByMonth" class="py-0">
      <v-row class="px-5 mb-3">
        <v-col cols="12" class="px-0 py-0">
          <h3 class="headline font-weight-medium mb-3">
            Resumo de Reembolsos por Mês
          </h3>
        </v-col>
      </v-row>
      <div style="width: 100%" v-if="resumeByMonth">
        <v-row
          class="px-md-5 mb-3 d-flex flex-column flex-md-row items-center"
          style="align-items: center"
        >
          <v-col cols="4" class="d-flex align-items-center w-100 py-0">
            <v-select
              v-model="selectedMonth"
              :items="months"
              item-text="name"
              item-value="value"
              label="Mês"
              outlined
              dense
              :disabled="loading"
            ></v-select>
          </v-col>
          <v-col
            cols="4"
            class="d-flex align-items-center py-0"
            style="align-items: center"
          >
            <v-select
              v-model="selectedYear"
              :items="years"
              label="Ano"
              outlined
              dense
              :disabled="loading"
            ></v-select>
          </v-col>
          <v-col
            cols="4"
            class="d-flex py-0 pt-3"
            style="min-height: 90px; align-items: start"
          >
            <v-btn
              color="primary"
              @click="fetchData"
              :loading="loading"
              :disabled="loading"
              style="margin: 0 0 !important;"
            >
              Pesquisar
            </v-btn>
          </v-col>
        </v-row>

        <v-row class="" >
          <v-col class="py-0">
            <material-stats-card
              color="green"
              icon="mdi-cash-refund"
              title="Reembolsos recebidos"
              :value="
                loading ? '-' : resumeByMonth.data.amount.completed.toReal()
              "
              sub-text-color="text-normal"
              :subText="
                loading
                  ? 'Carregando...'
                  : `Quantidade de resgates: ${resumeByMonth.data.count.completed}`
              "
            >
              <template v-if="loading" v-slot:content>
                <v-skeleton-loader type="text" class="mt-2"></v-skeleton-loader>
              </template>
            </material-stats-card>
          </v-col>
          <v-col class="py-0">
            <material-stats-card
              color="orange"
              icon="mdi-cash-register"
              title="Reembolsos à receber"
              :value="
                loading ? '-' : resumeByMonth.data.amount.pending.toReal()
              "
              sub-text-color="text-normal"
              :subText="
                loading
                  ? 'Carregando...'
                  : `Quantidade de resgates: ${resumeByMonth.data.count.pending}`
              "
            >
              <template v-if="loading" v-slot:content>
                <v-skeleton-loader type="text" class="mt-2"></v-skeleton-loader>
              </template>
            </material-stats-card>
          </v-col>
          <v-col
            v-if="
              resumeByMonth.data.amount.pix_completed > 0 &&
                resumeByMonth.data.count.pix_completed > 0
            "
            class="py-0"
          >
            <material-stats-card
              color="green"
              icon="mdi-cash-refund"
              title="Reembolsos PIX"
              :value="
                loading ? '-' : resumeByMonth.data.amount.pix_completed.toReal()
              "
              sub-text-color="text-normal"
              :subText="
                loading
                  ? 'Carregando...'
                  : `Quantidade de resgates: ${resumeByMonth.data.count.pix_completed}`
              "
            >
              <template v-if="loading" v-slot:content>
                <v-skeleton-loader type="text" class="mt-2"></v-skeleton-loader>
              </template>
            </material-stats-card>
          </v-col>
          <v-col class="py-0">
            <material-stats-card
              color="#00cec9"
              icon="mdi-cash-multiple"
              title="Valor Total"
              :value="loading ? '-' : resumeByMonth.data.amount.total.toReal()"
              sub-text-color="text-normal"
              :subText="
                loading
                  ? 'Carregando...'
                  : `Quantidade de resgates: ${resumeByMonth.data.count.total}`
              "
            >
              <template v-if="loading" v-slot:content>
                <v-skeleton-loader type="text" class="mt-2"></v-skeleton-loader>
              </template>
            </material-stats-card>
          </v-col>
        </v-row>

        <v-row
          v-if="resumeByMonth && resumeByMonth.data.period"
          class="pb-0 pt-5"
        >
          <v-col class="text-center px-0 py-0" style="padding: 0 !important;">
            <small class="text-caption">
              Dados disponíveis desde:
              {{ formatDate(resumeByMonth.data.initialData) }}
            </small>
          </v-col>
        </v-row>
      </div>
    </v-col>
  </v-row>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      loading: false,
      selectedMonth: new Date().getMonth() + 1,
      selectedYear: new Date().getFullYear(),
      months: [],
      years: []
    };
  },
  computed: {
    ...mapGetters("refunds", ["getResumeByMonth"]),
    resumeByMonth() {
      return this.getResumeByMonth;
    }
  },
  watch: {
    selectedYear() {
      this.generateMonthsList();
    },
    "resumeByMonth.data.initialData"() {
      this.generateYearsList();
      this.generateMonthsList();
    }
  },
  created() {
    this.generateDefaultMonthsList();
    this.fetchData();
  },
  methods: {
    ...mapActions("refunds", ["fetchRefundsResumeByMonth"]),
    async fetchData() {
      this.loading = true;
      try {
        await this.fetchRefundsResumeByMonth({
          year: this.selectedYear,
          month: this.selectedMonth
        });

        if (this.resumeByMonth && this.resumeByMonth.initialData) {
          this.generateYearsList();
          this.generateMonthsList();
        }
      } catch (error) {
        this.$notify({
          message: "Erro ao buscar dados",
          icon: "error",
          type: "error"
        });
      } finally {
        this.loading = false;
      }
    },
    generateDefaultMonthsList() {
      this.months = [
        { name: "Janeiro", value: 1 },
        { name: "Fevereiro", value: 2 },
        { name: "Março", value: 3 },
        { name: "Abril", value: 4 },
        { name: "Maio", value: 5 },
        { name: "Junho", value: 6 },
        { name: "Julho", value: 7 },
        { name: "Agosto", value: 8 },
        { name: "Setembro", value: 9 },
        { name: "Outubro", value: 10 },
        { name: "Novembro", value: 11 },
        { name: "Dezembro", value: 12 }
      ];
    },
    generateMonthsList() {
      this.generateDefaultMonthsList();

      if (!this.resumeByMonth || !this.resumeByMonth.data.initialData) {
        return;
      }

      const initialDate = new Date(this.resumeByMonth.data.initialData);
      const initialYear = initialDate.getFullYear();
      const initialMonth = initialDate.getMonth() + 1;

      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const currentMonth = currentDate.getMonth() + 1;

      if (this.selectedYear === initialYear) {
        this.months = this.months.filter(month => month.value >= initialMonth);
      } else if (this.selectedYear === currentYear) {
        this.months = this.months.filter(month => month.value <= currentMonth);
      } else if (this.selectedYear > currentYear) {
        this.months = [];
      }

      if (this.months.length > 0) {
        const monthExists = this.months.some(
          month => month.value === this.selectedMonth
        );
        if (!monthExists) {
          this.selectedMonth = this.months[0].value;
        }
      }
    },
    generateYearsList() {
      if (!this.resumeByMonth || !this.resumeByMonth.data.initialData) {
        const currentYear = new Date().getFullYear();
        this.years = [currentYear - 1, currentYear, currentYear + 1];
        return;
      }

      const initialDate = new Date(this.resumeByMonth.data.initialData);
      const initialYear = initialDate.getFullYear();

      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();

      this.years = [];
      for (let year = initialYear; year <= currentYear + 1; year++) {
        this.years.push(year);
      }

      if (!this.years.includes(this.selectedYear)) {
        this.selectedYear = currentYear;
      }
    },
    formatDate(dateString) {
      if (!dateString) return "";
      return moment(dateString).format("DD/MM/YYYY");
    }
  }
};
</script>
